import React from "react"
import types from "prop-types"
import { isEmpty, isEqual, sortBy } from "lodash-es"
import { useSelector } from "react-redux"
import { organizationUsersById } from "reduxSlices/organizationUsersSlice"
import { useTaskFormContext } from "contexts/TaskFormContext"
/* eslint-disable max-len */
import TaskUserList from "views/FormSubmission/FormSubmissionTabs/ActivitiesContent/TaskForms/TaskFields/UI/TaskUserList"
/* eslint-enable max-len */

const TaskAssigneeList = ({ className = "" }) => {
  const { removeAssigneeId, taskAssigneeIds } = useTaskFormContext()
  const assignedUsers = useSelector(organizationUsersById(taskAssigneeIds), isEqual)

  if (isEmpty(taskAssigneeIds)) return null

  const sortedAssignedUsers = sortBy(assignedUsers, ["lastName", "firstName"])

  return (
    <TaskUserList className={className} removeUser={removeAssigneeId} users={sortedAssignedUsers} userDescriptor="assignee" />
  )
}

TaskAssigneeList.propTypes = {
  className: types.string,
}

export default TaskAssigneeList
